<template>
    <div class="wrapper">
        <es-background-particles/>
        <div class="page-container container">
            <transition name="fade">
                <es-notification :text="'Thank you! Your message was sent.'" v-if="notificationShown"></es-notification>
            </transition>
            <es-header :reversedColors="isContactUsOpen"
                       :enableBackgroundForSmallerScreens="!isContactUsOpen"
                       :isCloseButtonVisible="isContactUsOpen"
                       @close="isContactUsOpen = false"/>
            <es-side-navigation :currentSectionPositionIndex="currentSectionPositionIndex"/>
            <es-landing ref="landing"
                        @contact-us-click="isContactUsOpen = true"/>
            <es-contact-form-modal
                    v-if="isContactUsOpen"
                    @closeModal="isContactUsOpen = false"
                    @sending-success="handleMessageSent"/>
            <transition name="button-appearance">
                <es-contact-us-button-compact v-if="currentSectionPositionIndex !== 0"
                                              @click="isContactUsOpen = true"/>
            </transition>
            <es-services ref="services"/>
            <es-about ref="about"/>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => {
            return {
                isContactUsOpen: false,
                notificationShown: false,
                currentSectionPositionIndex: 0
            }
        },
        mounted() {
            this.addScrollingPositionHandler();
        },
        watch: {
            '$route': {
                handler: (to) => {
                    document.title = to.meta.title || 'Entropy Spot'
                },
                immediate: true
            }
        },
        methods: {
            handleMessageSent() {
                this.isContactUsOpen = false;
                this.notificationShown = true;
                setTimeout(() => this.notificationShown = false, 3000);
            },
            updateCurrentSectionPositionIndex(newIndex) {
                if (newIndex !== this.currentSectionPositionIndex) {
                    this.currentSectionPositionIndex = newIndex;
                }
            },
            addScrollingPositionHandler() {
                const sectionNames = ['landing', 'services', 'about'];
                const sections = sectionNames.map(name => this.$refs[name].$el);
                const sectionMargin = 300;

                window.addEventListener("scroll", () => {
                    const newSectionIndex = sections.length - [...sections]
                        .reverse()
                        .findIndex((section) => window.scrollY >= section.offsetTop - sectionMargin) - 1;
                    this.updateCurrentSectionPositionIndex(newSectionIndex)
                });
            }
        }
    }
</script>
<style lang="scss">
    @import './src/assets/styles/variables/variables';

    .particles-js-canvas-el {
        width: 100%;
        position: absolute;
        height: calc(3 * 100vh) !important; // number of sections * screen height
    }

    .wrapper {
        background: $primary;
        position: absolute;
        left: 0;
        right: 0;

        .page-container {
            position: relative;
            max-width: $page-max-width;
            margin: auto;
        }
    }


    /* Transitions */
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .button-appearance-enter-active {
        animation: button-enter .3s;
    }

    .button-appearance-leave-active {
        animation: button-enter .4s reverse;
    }
</style>
